import {TranslationLibKey} from "./locale";
import {IconProps} from "../component/snippet/icon/Icon";
import {ButtonStyle} from "../component/snippet/button/Button";
import {Color} from "./color";

export class Action {
    static ACTIVATE: Action = new Action(TranslationLibKey.ACTION_ACTIVATE, {name: "toggle_on"});
    static DEACTIVATE: Action = new Action(TranslationLibKey.ACTION_DEACTIVATE, {name: "toggle_off", outlined: true});

    static BACK: Action = new Action(TranslationLibKey.ACTION_BACK, {name: "arrow_back"});
    static NEXT: Action = new Action(TranslationLibKey.ACTION_NEXT, {name: "arrow_forward"});

    static CANCEL: Action = new Action(TranslationLibKey.ACTION_CANCEL, {name: "cancel", outlined: true});
    static CLOSE: Action = new Action(TranslationLibKey.ACTION_CLOSE, {name: "close"});

    static REMOVE: Action = new Action(TranslationLibKey.ACTION_REMOVE, {name: "cancel", outlined: true});
    static REMOVE_ALL: Action = new Action(TranslationLibKey.ACTION_REMOVE_ALL, this.REMOVE.icon);

    static COLLAPSE: Action = new Action(TranslationLibKey.ACTION_COLLAPSE, {name: "keyboard_arrow_up"});
    static EXPAND: Action = new Action(TranslationLibKey.ACTION_EXPAND, {name: "keyboard_arrow_down"});

    static DOWNLOAD: Action = new Action(TranslationLibKey.ACTION_DOWNLOAD, {name: "download"});
    static DOWNLOAD_ALL: Action = new Action(TranslationLibKey.ACTION_DOWNLOAD_ALL, this.DOWNLOAD.icon);
    static UPLOAD: Action = new Action(TranslationLibKey.ACTION_UPLOAD, {name: "upload"});

    static EXPORT: Action = new Action(TranslationLibKey.ACTION_EXPORT, this.DOWNLOAD.icon);
    static IMPORT: Action = new Action(TranslationLibKey.ACTION_IMPORT, this.UPLOAD.icon);

    static COPIED: Action = new Action(TranslationLibKey.ACTION_COPIED, {name: "check"});
    static COPY: Action = new Action(TranslationLibKey.ACTION_COPY, {name: "content_copy", outlined: true});

    static NEW: Action = new Action(TranslationLibKey.ACTION_NEW, {name: "add"}, ButtonStyle.PRIMARY_GREEN);
    static ADD: Action = new Action(TranslationLibKey.ACTION_ADD, {name: "add"}, ButtonStyle.PRIMARY_GREEN);
    static DELETE: Action = new Action(TranslationLibKey.ACTION_DELETE, {name: "delete", colorIcon: Color.DANGER_MAIN});
    static DUPLICATE: Action = new Action(TranslationLibKey.ACTION_DUPLICATE, {name: "file_copy"});
    static EDIT: Action = new Action(TranslationLibKey.ACTION_EDIT, {name: "edit", outlined: true});

    static SAVE: Action = new Action(TranslationLibKey.ACTION_SAVE, {name: "save"}, ButtonStyle.PRIMARY_GREEN);
    static SEND: Action = new Action(TranslationLibKey.ACTION_SEND, {name: "send"});
    static VALIDATE: Action = new Action(TranslationLibKey.ACTION_VALIDATE, {name: "verified"});

    static OPEN: Action = new Action(TranslationLibKey.ACTION_OPEN, {name: "open_in_new"});
    static LEAVE: Action = new Action(TranslationLibKey.ACTION_LEAVE, {name: "logout"});

    static MORE: Action = new Action(TranslationLibKey.ACTION_MORE, {name: "more_vert"});
    static MORE_ACTIONS: Action = new Action(TranslationLibKey.ACTION_MORE_ACTIONS, this.MORE.icon);

    static SEARCH: Action = new Action(TranslationLibKey.ACTION_SEARCH, {name: "search"});
    static CLEAR: Action = new Action(TranslationLibKey.ACTION_CLEAR, {name: "close"});
    static CLEAR_SEARCH: Action = new Action(TranslationLibKey.ACTION_CLEAR_SEARCH, this.CLEAR.icon);

    static SHOW: Action = new Action(TranslationLibKey.ACTION_SHOW, {name: "visibility", outlined: true});
    static HIDE: Action = new Action(TranslationLibKey.ACTION_HIDE, {name: "visibility_off", outlined: true});

    labelKey: string;
    icon: IconProps;
    style: ButtonStyle;

    constructor(labelKey: string, icon: IconProps, style: ButtonStyle = ButtonStyle.DEFAULT_MIDNIGHT_LIGHT) {
        this.labelKey = labelKey;
        this.icon = icon;
        this.style = style;
    }
}
